<template>
  <div id="app">
    <div class="home-header" :class="{'headerStyle': ((['Home', 'Detail'].indexOf($route.name) > -1 && scroll > 10) || $route.name === 'List')}">
      <div class="header-title" :style="{'color': ((['Home'].indexOf($route.name) > -1 && scroll > 10) || ['List', 'Detail'].indexOf($route.name) > -1) ? '#000' : '#fff'}">BIRGERSSON</div>
      <div class="header-control">
        <div class="header-control-item" :style="{'color': ((['Home'].indexOf($route.name) > -1 && scroll > 10) || ['List', 'Detail'].indexOf($route.name) > -1) ? '#000' : '#fff'}">致电我们</div>
      </div>
    </div>
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <router-view />
    <div class="home-footer">
      <div class="footer-header">
        <div class="footer-header-item" v-for="(item, index) in footerArr" :key="index">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return {
      scroll: 0,
      footerArr: [
        { label: '帮助' },
        { label: '订制与赠礼服务' },
        { label: '路易威登的世界' },
        { label: '关注我们' },

        { label: '欢迎致电 400 6588 555 联系咨询顾问。您还可以给我们 发送消息 或 发电子邮件' },
        { label: '维修' },
        { label: '最新消息' },
        { label: '订阅电子报 以抢先访问最新系列、活动和视频。' },

        { label: '常见问题解答' },
        { label: '个性化定制' },
        { label: '时装秀' },
        { label: '关注社交账号' },

        { label: '产品保养' },
        { label: '个性化赠礼' },
        { label: '艺术与文化' },
        { label: '艺术与文化' },
        
        { label: '下载我们的应用程序' },
        { label: '品牌' },
        { label: '环保与可持续性' },
        { label: '路易威登基金会' },
      ]
    }
  },
  mounted() {
    this.$store.commit('updateCount')
    window.addEventListener('scroll', this.dataScroll, false);
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.dataScroll, false)
  },
  methods:{
    dataScroll: function () {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      },
    
  }
};
</script>

<style scoped lang="less">
.home {
  height: 100%;
}
.headerStyle {
  transition: all .3s cubic-bezier(.39,.575,.565,1);
  box-shadow: inset 0 -1px 0 0 #eae8e4;
  background: #fff;
}
.home-header {
  width: 100%;
  height: 90px;
  padding: 0 3.125vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;
  .header-title {
    display: flex;
    align-items: center;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    font-size: 36px;
    font-weight: 500;
    color: #fff;
  }
  .header-control {
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: 40px;
    font-size: 12px;
    cursor: pointer;
    .header-control-item {
      color: #fff;
    }
  }
}


.footer-header {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding-bottom: 40px;
  padding-top: 40px;
  padding-left: 4.6875vw;
  padding-right: 4.6875vw;
}

.footer-header-item {
  width: calc(25% - 8px);
  font-size: 14px;
  margin-bottom: 10px;
}
</style>